<template>
  <div>
    <Content title="SLA Performance Praqualifikasi KPLH" />
  </div>
</template>
<script>
export default {
  components: {
    Content: () => import('@/components/dashboard/main-kpi/content.vue'),
  },
}
</script>
